/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


export const getCurrentUserResponse = zod.object({
  "id": zod.string().uuid(),
  "primaryEmail": zod.string(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "isActive": zod.boolean(),
  "isAnonymous": zod.boolean(),
  "isPrimaryEmailVerified": zod.boolean(),
  "isPhoneVerified": zod.boolean(),
  "lastSeenDate": zod.string().datetime({}).nullish(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "email": zod.string(),
  "isEmailVerified": zod.boolean()
})

export const updateCurrentUserBodyFirstNameMax = 255;

export const updateCurrentUserBodyLastNameMax = 255;

export const updateCurrentUserBodyPhoneMax = 20;



export const updateCurrentUserBody = zod.object({
  "firstName": zod.string().min(1).max(updateCurrentUserBodyFirstNameMax),
  "lastName": zod.string().min(1).max(updateCurrentUserBodyLastNameMax),
  "phone": zod.string().max(updateCurrentUserBodyPhoneMax).nullish()
})

export const updateCurrentUserResponse = zod.object({
  "id": zod.string().uuid(),
  "primaryEmail": zod.string(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "isActive": zod.boolean(),
  "isAnonymous": zod.boolean(),
  "isPrimaryEmailVerified": zod.boolean(),
  "isPhoneVerified": zod.boolean(),
  "lastSeenDate": zod.string().datetime({}).nullish(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "email": zod.string(),
  "isEmailVerified": zod.boolean()
})

